module.exports = __webpack_public_path__ + "img/sierra_high_ba_list.c007e3ce.jpg";